import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '@/router/routes'
import store from '@/store/index'

Vue.use(VueRouter)


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior: function (to, from, savedPosition) {
        if (to.hash) {
            return {selector: to.hash}
        } else {
            return {x: 0, y: 0}
        }
    },
})

router.beforeEach((to, from, next) => {
    const isAuthenticated = store.getters['auth/isLoggedIn']
    const routeRequiresAuth = to.matched.some(record => record.meta.requiresAuth)
    const isStartOfApp = !from.name
    const routeIsForGuest = to.matched.some(record => record.meta.forGuest)

    if (isStartOfApp && routeRequiresAuth && !isAuthenticated) {
        next({name: 'login', query: {...to.query}});
    } else if (routeIsForGuest && isAuthenticated) {
        next({name: 'home', query: {...to.query}});
    } else {
        next()
    }
})

export default router
